// SEO audit batch 3, Part 3 — one shared "may the estimator load now?" gate.
//
// On pages where the estimator sits below the first screen (home, /pricing)
// its JS chunk and the GET /api/pricing-config fetch wait until either the
// estimator section is about to scroll into view (LazyEstimator's
// IntersectionObserver) or the visitor clicks any "Get an Instant Estimate"
// button (the delegated click tracker in lib/analytics.js calls
// `preloadEstimator`, so the chunk is already in flight when /estimate
// renders). /estimate itself imports the widget statically, so it loads right
// away there. Browser-only: the prerenderer never opens the gate, it renders
// the same-size placeholder that the first client render shows.

let opened = false;
let openGate = null;
const gate = new Promise((resolve) => { openGate = resolve; });

/** Open the gate (idempotent): the estimator chunk starts downloading now. */
export const preloadEstimator = () => {
  if (opened) return;
  opened = true;
  openGate();
};

/** True once the gate has been opened. */
export const estimatorGateOpen = () => opened;

/** Resolves once the gate is open. */
export const whenEstimatorAllowed = () => gate;
